
const styles = {
    footerIcon: {
        color: '#fff', fontSize: '30px'
    },
    footerHeading: {
        color: '#fff', fontSize: '25px', textTransform: 'uppercase', letterSpacing: '1px'
    },
    footerPara: {
        color: 'rgb(184, 184, 184)', fontSize: '18px', lineHeight: '35px'
    },
    footerCol: {
        lineHeight: '50px'
    },
    footerDiv: {
        marginTop: '60px', marginBottom: '60px',
    },
    separator: {
        width: '100%', height: '0.01rem', border: 'none', backgroundColor: 'gray', margin: '0px'
    },
    footerBtn: {
        height: '50px', width: '50px', backgroundColor: '#1f8bf3', color: '#fff', borderColor: '#1f8bf3', 
        marginLeft: '10px', fontWeight: '600', letterSpacing: '1px', display: 'flex', alignItems: 'center', 
        justifyContent: 'center'
    },
    footerInput: {
        height: '50px', width: '250px', paddingLeft: '20px', backgroundColor: '#2a2a2a', border: 'none', color: '#fff',
    },
    subscribeDiv: {
        display: 'flex', alignItems: 'center'
    },
    footerIcond: {
        width: '50px', height: "50px", backgroundColor: '#2a2a2a', border: 'none', display: 'flex',
        justifyContent: 'center', alignItems: 'center', margin: '10px', color: '#fff', opacity: '0.8', 
    }
}

export default styles;